"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.urlify = void 0;
var _reactStringReplace = _interopRequireDefault(require("react-string-replace"));
var _dsWeb = require("@olxbr/ds-web");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var urlify = exports.urlify = function urlify() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var undeline = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var replaced = (0, _reactStringReplace["default"])(text, /(\[.*?\]\(.*?\))/gi, function (match, i) {
    var regex = /\[(.*?)\]\((.*?)\)/gi;
    var values = regex.exec(match);
    if (values[2].includes('javascript:')) {
      return text;
    }
    if (values.length < 3) {
      return null;
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Link, {
      target: target ? '_blank' : null,
      underline: undeline ? true : false,
      href: values[2],
      size: "medium",
      children: values[1]
    }, "".concat(match).concat(i).concat(new Date().toISOString()));
  });
  replaced = (0, _reactStringReplace["default"])(replaced, /(https?:\/\/[^\s]+)/g, function (match, i) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Link, {
      target: target ? '_blank' : null,
      underline: undeline ? true : false,
      href: match,
      size: "medium",
      children: match
    }, "".concat(match).concat(i).concat(new Date().toISOString()));
  });
  replaced = (0, _reactStringReplace["default"])(replaced, /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/, function (match, i) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Link, {
      target: target ? '_blank' : null,
      underline: undeline ? true : false,
      href: "mailto:".concat(match),
      size: "medium",
      children: match
    }, "".concat(match).concat(i).concat(new Date().toISOString()));
  });
  return replaced;
};